import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { teacherSatisfactionData } from '../../../Constant/charts';
import { useTranslation } from 'react-i18next';

const TeacherSatisfactionChart = () => {
  const { t } = useTranslation();

  // Translate the data
  const translatedData = teacherSatisfactionData.map(item => ({
    ...item,
    name: t(item.name)
  }));

  return (
    <div className="bg-white shadow-md p-4 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">{t('TeacherSatisfaction')}</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={translatedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="score" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TeacherSatisfactionChart;
